import {
  STATUS_KLEUREN_LICHT,
  STATUS_KLEUREN_TEKST,
  STATUS_TEKST,
  type KaartStatus,
} from '@/types/domain';
import { StatusStip } from './StatusStip';
import './ui.css';

interface StatusBadgeProps {
  status: KaartStatus;
}

/**
 * Statuslabel met hetzelfde silhouet en dezelfde kleur als op de kaart.
 *
 * Altijd de woorden van de laag Afkoppelen. Een badge staat in een rij, een
 * tabel of een formulier, en daar gaat het over de woning: wordt er
 * afgekoppeld, en hoe ver is dat. Wat de bewoner daarnaast zelf doet staat
 * er los van en hoort niet in dezelfde chip.
 */
export function StatusBadge({ status }: StatusBadgeProps): JSX.Element {
  return (
    <span
      className="badge"
      style={{
        background: STATUS_KLEUREN_LICHT[status],
        color: STATUS_KLEUREN_TEKST[status],
      }}
    >
      <StatusStip status={status} formaat={12} />
      {STATUS_TEKST.afkoppelen[status]}
    </span>
  );
}
